import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function GoaPremium() {
    const heading = "Premium Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Goa Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-goa/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Premium Room",
            },
        ]
    }

    const roomBanner = {
        image: "/image/goa-premium-room-detail.webp",
    };

    const roomQuote = {
        content: "Our Premium Rooms are all about the little extras that make a stay feel special. Whether it's the high-thread-count linens or the way the evening light hits the room, it feels high-end yet completely relaxed. It’s the perfect choice for travelers who want a top-tier experience with plenty of room to stretch out.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "30",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/goa-premium-room-gallery-1.webp" },
        { image: "/image/goa-premium-room-gallery-2.webp" },
        { image: "/image/goa-premium-room-gallery-3.webp" },
        { image: "/image/goa-premium-room-gallery-4.webp" },
        // { image: "/image/goa-premium-room-gallery-5.webp" },
        // { image: "/image/goa-premium-room-gallery-6.webp" },
        // { image: "/image/goa-premium-room-gallery-7.webp" },
    ];

    const roomEquipment = {
        description: "Experience the comfort of a well-equipped room designed to give you a relaxing space to rest, refresh, and recharge.",
        equipment: [
        [
            "Premium 100% Cotton Bedding & Duvets",
            "Evening Turndown service for a fresh room at night",
            "24-Hour personalized Room Service",
            "In-room Mini-Fridge and Refreshment center",
        ],
        [
            "Coffee/Tea station replenished daily",
            "Large 42-inch LED TV for downtime",
            "Reliable, high-speed Wi-Fi",
            "Bidet, Hair Dryer, and Makeup Mirror",
        ],
        [
            "Secure In-room Safety Box",
            "Dual Voltage Adaptors for international devices",
            "Comfortable seating/lounging area",
            "Work desk with accessible power points",
        ]
    ]
    };

    const roomBook = {
        location: "Goa",
        title: "Premium Room",
        desc: "Settle into the refined comfort of the Premium Room at De Coracao Goa, where spacious interiors meet thoughtful details. Designed for relaxed stays, it offers plush bedding, modern conveniences, and a welcoming setting to unwind after a day of exploring Goa.",
        details: [
            "1 King Bed + 1 Extra Mattress ",
            "Up to 3 Guests",
            "30 sq mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Super Deluxe Room',
                bg: '/image/goa-other-room-2.webp',
                slug: '/resort-de-coracao-goa/super-deluxe-room',
                details: [
                    "1 King Size Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "28 sq mt",
                ],
            },

            {
                title: 'Suite Room',
                bg: '/image/goa-other-room-3.webp',
                slug: '/resort-de-coracao-goa/suite-room',
                details: [
                    "1 King Size Bed + Living Room Seating",
                    "3 Guests",
                    "37 sq.mt.",
                ],
            },

            {
                title: 'Standard Room',
                bg: '/image/goa-other-room-6.webp',
                slug: '/resort-de-coracao-goa/standard-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    "21 sq. mt",
                ],
            },

            {
                title: 'Deluxe Room',
                bg: '/image/goa-other-room-4.webp',
                slug: '/resort-de-coracao-goa/deluxe-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    "24 sq mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-goa/room-listing" }
    }

    return (
        <>
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
